import React, {useEffect, useState} from "react";
import {useFormik} from "formik";
import {create} from "../../../api/endpoints/CrudApi";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import GenericButton, {EButtonColor, EButtonIcons, EButtonStyle} from "../button/GenericButton";
import {getAllValuesForAttribute} from "../../../api/endpoints/CustomApi";
import LdapAttribute from "../../../../models/LdapAttribute";
import AbsenceRequestType from "../../../../models/AbsenceType";
import {MultiSelect} from "primereact/multiselect";

interface ISmallFormProps {
    initialValues: any,
    path: string,
    hide: () => void,
    isAbsenceType?: boolean,
    addNewDataToTable: React.Dispatch<any>,
}

/**
 * Only for object with name and enumName as objects
 * @param props
 * @constructor
 */
const SmallForm = (props: ISmallFormProps) => {
    const [descriptionLdap, setDescriptionLdap] = useState<LdapAttribute>();
    const [absenceTypeRoleSelection, setAbsenceTypeRoleSelection] = useState<any[]>();
    useEffect(() => {
        if (props.isAbsenceType) {
            (async () => {
                setDescriptionLdap(await getAllValuesForAttribute('description'));
            })();
        }
    }, []);

    const formik = useFormik({
        initialValues: props.isAbsenceType ? props.initialValues as AbsenceRequestType : props.initialValues,

        onSubmit:
            async values => {
                values.id = undefined;
                await create(props.path, values).then(res => res.status === 201 ? props.addNewDataToTable(res.data) : undefined);
                formik.resetForm();
            },
    });

    const formikTouched: any = formik.touched;
    const formikErrors: any = formik.errors;

    const isFormFieldValid = (name: string) => !!(formikTouched[name] && formikErrors[name]);
    const getFormErrorMessage = (name: string) => {
        return isFormFieldValid(name) && <small className="p-error">{formikErrors[name]}</small>;
    };

    async function goToBackend(values: any) {
        values.id = undefined;
        await create(props.path, formik.values).then(res => res.status === 201 ? props.addNewDataToTable(res.data) : undefined);
        formik.resetForm();
        props.hide();
    }

    return <>
        <form>
            {props.isAbsenceType &&
                <div>
                    <div className="h-1rem"></div>
                    <span>Odaberite naziv tipa odsustva koji će biti prikazan korisniku te tipove zaposlenika koji će imati pravo izabrati ovaj tip odsustva.</span>
                    <div className="h-2rem"></div>
                </div>

            }
            <div>
                <div style={{border: "transparent"}}>
                    <div className="p-fluid grid" style={{paddingTop: '20px'}}>
                        <div className="field col-6  md:col-6">
                            <span className="p-float-label">
                                <InputText id="name" name="name" value={formik.values.name}
                                           onChange={formik.handleChange}/>
                                <label htmlFor="name"
                                       className={classNames({'p-error': isFormFieldValid('name')})}>Naziv</label>
                            </span>
                            {getFormErrorMessage('name')}
                        </div>
                        {
                            props.isAbsenceType !== undefined && props.isAbsenceType ?
                                <>
                                    <div className="field col-6">
                                        <span className="p-float-label">
                                                <MultiSelect id="absenceTypeRoleSelection"
                                                             value={absenceTypeRoleSelection}
                                                             options={descriptionLdap?.attributeValuesEnum}
                                                             onChange={(e) => {
                                                                 setAbsenceTypeRoleSelection(e.value);
                                                                 if (e.value !== undefined) {
                                                                     let i: any[] = e.value;
                                                                     let roles = i.map(attribute => attribute.enumName).join(", ");
                                                                     formik.setFieldValue("roles", roles);
                                                                 }
                                                             }}
                                                             dataKey="name" optionLabel="name"/>
                                            <label htmlFor="absenceTypeRoleSelection">Tipovi zaposlenika</label>
                                        </span>
                                    </div>
                                </>
                                :
                                <></>
                        }
                    </div>
                </div>
                <div className="h-1rem"></div>
                <div className="flex flex-row-reverse">
                    <GenericButton type="submit" label="Spremi" icon={EButtonIcons.CHECK} styled={EButtonStyle.OUTLINED}
                                   onClick={goToBackend}
                                   color={EButtonColor.DARK_BLUE}></GenericButton>
                </div>
            </div>
        </form>
    </>
}
export default SmallForm;